import {
  SUBMIT_REGISTER_COMPLAINT_ACTION_REQUESTED,
  SUBMIT_REGISTER_COMPLAINT_ACTION_DISPATCHER,
  SUBMIT_REGISTER_COMPLAINT_ERROR_DISPATCHER,
  SUBMIT_EMPTY_REGISTER_COMPLAINT_STATE_ACTION,
  REGISTER_COMPLAINT_LOADING,
} from "./Action";

const initialState = {
  successData: { message: "", apiData: {} },
  failureData: { message: "", apiData: {} },
  loading: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SUBMIT_REGISTER_COMPLAINT_ACTION_REQUESTED:
      return { ...state, loading: true };
    case SUBMIT_REGISTER_COMPLAINT_ACTION_DISPATCHER:
      if (action.payload.data) {
        return {
          ...state,
          successData: {
            message: action.payload.data.message || "",
            apiData: action.payload.data,
          },
          loading: false,
        };
      } else {
        return { ...state, loading: false };
      }
    case SUBMIT_REGISTER_COMPLAINT_ERROR_DISPATCHER:
      if (action.payload.data) {
        return {
          ...state,
          successData: {
            message: action.payload.data.Message,
            apiData: action.payload.data,
          },
          loading: false,
        };
      } else {
        return { ...state, loading: false };
      }
    case REGISTER_COMPLAINT_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    case SUBMIT_EMPTY_REGISTER_COMPLAINT_STATE_ACTION:
      return {
        ...state,
        successData: {
          message: "",
          apiData: {}
        },
        loading: false,
      };
    default:
      return state;
  }
};

export default reducer;
